///<reference path='../../typings/index.d.ts' />
///<reference path='playbutton.ts' />

module agi.expressions.card.layer {
    import Config = agi.expressions.card.Config;
    import Event = agi.expressions.event.Event;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;

    export class SenderPlayButton extends PlayButton{
        constructor(
            container:HTMLElement, 
            measuringContainer:HTMLElement, 
            assets:AssetManifest
        ){
            super(container, measuringContainer,assets);
        }

        public init(){
            super.init();
            this.playButtonImg.src = this.assets.playButtonURLs.sender;
        }

    }
}